import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { TypeGetOrderSearchConditionsResponse } from '~/types/delivery-agency.types';

/**
 * [배송 주문 관리] 검색 필터 코드 조회 API
 */
export const fetchOrdersSearchConditions = async (): Promise<TypeGetOrderSearchConditionsResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetOrderSearchConditionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS_CODES
  );
  return data.data;
};

/**
 * [배송 주문 관리] 검색 필터 코드 조회 Query Hook
 */
export const useGetOrdersSearchConditionsQuery = (options?: { enabled?: boolean; silent?: boolean }) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.orderSearchConditions(),
    queryFn: fetchOrdersSearchConditions,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
    meta: options?.silent ? { silent: true } : undefined,
  });
};
